import { useApi, useToaster, type CustomerStoryCard } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { watch } from "vue";

export function useExpertCustomerStories() {
    const api = useApi();
    const toaster = useToaster();

    const query = useQuery<CustomerStoryCard[]>({
        queryKey: ["expert", "customer-stories"],
        queryFn: () => api.expert.getCustomerStoriesV2(),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    watch(() => query.error.value, (error) => {
        if (!error) return;
        toaster.create({ title: "Failed to load case studies", type: "error" });
    });

    return query;
}

export default useExpertCustomerStories;
